export interface InvitationForm {
  password: string;
  confirmPassword: string;
}

export enum InvitationFieldNames {
  Password = 'password',
  ConfirmPassword = 'confirmPassword',
}

export interface InviteNewUserForm {
  email: string;
  phone: string;
}

export enum InviteNewUserFieldNames {
  Email = 'email',
  Phone = 'phone',
}

export enum InvitationStep {
  Checking = 'checking',
  Register = 'register',
  Success = 'success',
  Duplicate = 'duplicate',
}
